import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: {},
    loginFlag: false,
    loginLevel: 0, // 未登录 0 登录非管理员 1 登录且管理员2
  },
  mutations: {
      setToken(state, data) {
        state.token = data
      },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setLoginFlag(state, loginFlag) {
      state.loginFlag = loginFlag
    },
    setLoginLevel(state, loginLevel) {
      state.loginLevel = loginLevel
    },
  },
  actions: {

  },
});
